import { render } from "./SupervisorResultsTab.vue?vue&type=template&id=7493afe4"
import script from "./SupervisorResultsTab.vue?vue&type=script&lang=js"
export * from "./SupervisorResultsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__